import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		PartnertypPzn: [],
	},
	filter: {
		UzivatelPracId: null as number | null,
		ProvozovnaId: null as number | null,
		Jmeno: null as string | null,
		PrijmeniFirma: null as string | null,
		Ulice: null as string | null,
		Obec: null as string | null,
		IcoNr: null as string | null,
		DicNr: null as string | null,
		TelNr: null as string | null,
		EMailAdresa: null as string | null,
		Kns: null as string | null,
		PartnertypPzn: null as number | null,
		PartnerkontaktId: null as number | null,
		CdbSynchronizedOnly: null as boolean | null,
	},
	tableSetting: {},
	localState: {
		createParams: null as object | null,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
